module.exports = __webpack_public_path__ + "static/media/comment-message.0adb63ac.svg";